export default __webpack_public_path__ + "static/N0097-821fd6b881da2f384b256430a2f99d2f.png";